/// <reference path="../../app.ts" />
/// <reference path="../subcataccordion.ts" />
/// <reference path="../isubcataccordion.ts" />
module Cfnc
{
    "use strict";

    export class ActScores extends SubCatAccordion implements IsubCatAccordion
    {
        difficulty: string;
        toolTipHeader: string = "Find colleges where your ACT scores are similar to recently admitted students.";

        typeCbs = [{ type: "ACT scores <= 15", isChecked: false },
            { type: "ACT scores 16 - 19", isChecked: false },
            { type: "ACT scores 20 - 23", isChecked: false },
            { type: "ACT scores 24 - 28", isChecked: false },
            { type: "ACT scores >= 29", isChecked: false }];

        public getSelectedTypes(): string[]
        {
            var selectedTypes = new Array<string>();
            this.selected = false;

            if ( this.difficulty !== 'undefined' )
            {
                switch ( this.difficulty )
                {
                    case "ACT scores <= 15":
                        this.typeCbs[0].isChecked = true;
                        this.typeCbs[1].isChecked = false;
                        this.typeCbs[2].isChecked = false;
                        this.typeCbs[3].isChecked = false;
                        this.typeCbs[4].isChecked = false;
                        break;
                    case "ACT scores 16 - 19":
                        this.typeCbs[0].isChecked = false;
                        this.typeCbs[1].isChecked = true;
                        this.typeCbs[2].isChecked = false;
                        this.typeCbs[3].isChecked = false;
                        this.typeCbs[4].isChecked = false;
                        break;
                    case "ACT scores 20 - 23":
                        this.typeCbs[0].isChecked = false;
                        this.typeCbs[1].isChecked = false;
                        this.typeCbs[2].isChecked = true;
                        this.typeCbs[3].isChecked = false;
                        this.typeCbs[4].isChecked = false;
                        break;
                    case "ACT scores 24 - 28":
                        this.typeCbs[0].isChecked = false;
                        this.typeCbs[1].isChecked = false;
                        this.typeCbs[2].isChecked = false;
                        this.typeCbs[3].isChecked = true;
                        this.typeCbs[4].isChecked = false;
                        break;
                    case "ACT scores >= 29":
                        this.typeCbs[0].isChecked = false;
                        this.typeCbs[1].isChecked = false;
                        this.typeCbs[2].isChecked = false;
                        this.typeCbs[3].isChecked = false;
                        this.typeCbs[4].isChecked = true;
                        break;
                }
                selectedTypes.push(this.difficulty );
                this.selected = true;
            }
            return selectedTypes;
        }

        public reset()
        {
            this.difficulty = null;
            this.selected = false;
        }
        
    }
} 